//  @ts-nocheck
// biome-ignore-all lint: 관심없음

import { cn } from '@module/lib/utils';
import * as React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'scrollbar-custom flex min-h-[80px] w-full rounded-md border border-borderBg03 bg-colorBg02 p-[17px] text-sm text-baseFg ring-offset-background placeholder:text-colorFg14 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
